import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  heroWrapper: {
    width: '100%',
    maxWidth: theme.gh_vars.maxWidth,
    padding: theme.spacing(3),
    margin: '0 auto',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.shape.borderRadius,
    backgroundSize: 'cover',
    overflow: 'hidden',
    minHeight: 200,
    [theme.breakpoints.up('md')]: {
      minHeight: 250,
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 300,
      padding: theme.spacing(5),
    },
  },
  heroContent: {
    position: 'relative',
    top: 0,
    zIndex: 1,
  },
}));
